import PropTypes from 'prop-types';
import React from 'react';
import ReactDatePicker from 'react-datepicker';
import moment from 'moment';
import styled from 'styled-components';
import 'react-datepicker/dist/react-datepicker.css';

import { InputStyle } from '../text_input';

/**
 * @visibleName Date Picker
 */

const DatePicker = ({ className, 'data-aid': dataAid, disabled, isError, onChange, placeholder, readOnly, value }) => {
  const selected = value ? moment(value) : null;

  return (
    <DatePickerWrapper data-aid={dataAid} isError={isError}>
      <ReactDatePicker
        className={className}
        disabled={disabled}
        onChange={onChange}
        placeholderText={placeholder}
        readOnly={readOnly}
        selected={selected}
      />
    </DatePickerWrapper>
  );
};

const DatePickerWrapper = styled.div`
  width: 100%;

  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__input-container {
    width: 100%;
  }

  .react-datepicker__input-container > input {
    ${InputStyle};
    flex: 1 1 auto;
    font-size: 13px;
    height: 32px;
    width: 100%;

    ::placeholder {
      color: ${p => p.theme.colors.gray500};
    }

    &:focus {
      outline: none;
    }
  }

  .react-datepicker__day {
    width: 33px;
    line-height: 33px;
    margin: 0;
    border-radius: 0;

    :hover {
      background-color: ${p => p.theme.colors.gray400};
    }

    :focus {
      outline: none;
    }

    &.react-datepicker__day--selected,
    &.react-datepicker__day--keyboard-selected {
      background-color: ${p => p.theme.colors.green400};
    }

    &.react-datepicker__day--outside-month {
      color: ${p => p.theme.colors.gray500};

      &:hover {
        color: ${p => p.theme.colors.gray800};
      }
    }
  }

  .react-datepicker-popper {
    z-index: 10;
    padding: 16px;

    background: ${p => p.theme.colors.white};
    box-shadow: 0 2px 12px ${p => p.theme.colors.gray400};
  }

  .react-datepicker__triangle {
    display: none;
  }

  .react-datepicker {
    border: none;
  }

  .react-datepicker__header {
    background: ${p => p.theme.colors.white};
    border-bottom: none;
  }

  .react-datepicker__current-month {
    font-size: 13px;
    font-family: ${p => p.theme.fontFamily.default};
    font-weight: normal;
  }

  .react-datepicker__day-name {
    color: ${p => p.theme.colors.gray400};
    border-radius: 0;
    margin-bottom: 0px;
  }

  .react-datepicker__navigation {
    border: 5px solid transparent;
  }

  .react-datepicker__navigation--previous {
    border-right-color: ${p => p.theme.colors.gray600};
    &:hover {
      border-right-color: ${p => p.theme.colors.gray700};
    }
  }

  .react-datepicker__navigation--next {
    border-left-color: ${p => p.theme.colors.gray600};
    &:hover {
      border-left-color: ${p => p.theme.colors.gray700};
    }
  }
`;

DatePicker.propTypes = {
  className: PropTypes.string,
  'data-aid': PropTypes.string,
  disabled: PropTypes.bool,
  isError: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
};

export default DatePicker;
